import { ReactNode, useEffect } from "react";
import { useUserActiveInactiveRoleMutation } from "../../../../features/portal/Products/productsApi";
import useError from "../../../../hooks/useError";

import { Button, Card, Space } from "antd";
import CustomModal from "../../../../components/ui/CustomModal";
import { toast } from "../../../../lib/toast";

export interface ModalConfirmProps<
  DataT = never,
  TypeT =
    | "SUCCESS"
    | "ADD"
    | "UPDATE"
    | "VIEW"
    | "CONFIRM"
    | "CONFIRM_FOR_APPROVAL"
    | "PRODUCT_ACTIVITY"
> {
  open: boolean;
  action?: boolean;
  buttonBgDeep?: boolean;
  handleClose: (val?: any) => void;
  type?: TypeT;
  data?: any;
  title?: ReactNode;
  subTitle?: ReactNode;
  buttonName?: string;
  loading?: boolean;
  children?: ReactNode;
  id?: any;
  name: any;
}

export default function UserProductAccessModal({
  title,
  action,
  buttonName,
  buttonBgDeep,
  subTitle,
  handleClose,
  children,
  type,
  data,
  loading,
  id,
  name,
  ...rest
}: ModalConfirmProps) {
  const [userActiveInactiveRole, { isError, error, isLoading, isSuccess }] =
    useUserActiveInactiveRoleMutation();
  useError(isError, error, "Uese ative inactive role update fail");

  const formattedName = name?.charAt(0).toUpperCase() + name?.slice(1);

  const handleActiveInactiveRole = () => {
    const newData = {
      userId: Number(id),
      projectId: Number(data?.project?.id),
      roleId: Number(data?.role?.id),
      // status: data?.role?.status === "active" ? "inactive" : "active",
      status: data?.status === "active" ? "inactive" : "active",
    };

    userActiveInactiveRole(newData);
  };

  useEffect(() => {
    if (isSuccess) {
      handleClose();
      toast(
        "success",
        `${
          data?.status === "active"
            ? `${formattedName} has been marked as inactive successfully`
            : `${formattedName} is now active again`
        }`
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess]);

  return (
    <>
      <CustomModal
        {...rest}
        handleClose={handleClose}
        width={400}
        footer={null}
      >
        <Card className="w-full">
          <h4 className=" font-semibold text-[18px] text-[#5E718D] text-center">
            {`${
              data?.status === "active" ? "Inactive" : "Active"
            } ${formattedName}!`}
          </h4>

          <div className=" font-normal text-[14px] text-[#5E718D] text-center">
            {`Are you sure you want to ${
              data?.status === "active" ? "inactive" : "active"
            } ${formattedName} of ${data?.project?.name}?`}
          </div>

          <Space className="flex justify-center gap-2 mt-6">
            <Button
              className="normal-dark-button modal-button"
              size="middle"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              className="modal-button"
              type="primary"
              htmlType="submit"
              size="middle"
              onClick={handleActiveInactiveRole}
              loading={isLoading}
            >
              {`Yes, ${data?.status === "active" ? "Inactive" : "Active"}`}
            </Button>
          </Space>
        </Card>
      </CustomModal>
    </>
  );
}
